(() => {
  const money = (cents, format) => {
    const value = (cents / 100).toFixed(2);
    const [whole, dec] = value.split('.');
    const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec)
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + dec);
  };

  const updateCartCount = () =>
    fetch('/cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });
    }).catch(() => {});

  // Sale countdown: one fixed deadline for everyone; hides when it has passed
  const bar = document.querySelector('[data-countdown]');
  const deadline = bar ? Date.parse(bar.dataset.countdown) : NaN;
  const pad = n => String(n).padStart(2, '0');
  const tick = () => {
    const left = deadline - Date.now();
    const saleLine = document.querySelector('[data-sale-ends]');
    if (!(left > 0)) {
      if (bar) bar.hidden = true;
      if (saleLine) saleLine.hidden = true;
      return false;
    }
    const s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
    if (bar) {
      bar.hidden = false;
      bar.querySelector('[data-cd-d]').textContent = pad(d);
      bar.querySelector('[data-cd-d-wrap]').hidden = d === 0;
      bar.querySelector('[data-cd-h]').textContent = pad(h);
      bar.querySelector('[data-cd-m]').textContent = pad(m);
      bar.querySelector('[data-cd-s]').textContent = pad(sec);
    }
    if (saleLine) {
      saleLine.hidden = false;
      saleLine.querySelector('[data-sale-clock]').textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    }
    return true;
  };
  if (!isNaN(deadline) && tick()) {
    const timer = setInterval(() => { if (!tick()) clearInterval(timer); }, 1000);
  }

  // Delivery dates
  const addBusinessDays = days => {
    const d = new Date();
    let add = days;
    while (add > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) add--; }
    return d;
  };
  document.querySelectorAll('[data-date]').forEach(el => {
    const fmt = { month: 'short', day: 'numeric' };
    const max = addBusinessDays(parseInt(el.dataset.date, 10) || 0);
    const minDays = parseInt(el.dataset.dateMin, 10);
    if (!minDays || minDays >= (parseInt(el.dataset.date, 10) || 0)) {
      el.textContent = max.toLocaleDateString(undefined, fmt);
      return;
    }
    const min = addBusinessDays(minDays);
    const df = new Intl.DateTimeFormat(undefined, fmt);
    el.textContent = df.formatRange
      ? df.formatRange(min, max)
      : `${df.format(min)} – ${df.format(max)}`;
  });

  const section = document.querySelector('[data-product-section]');
  if (!section) return;
  const data = JSON.parse(section.querySelector('[data-product-json]').textContent);
  const form = section.querySelector('[data-product-form]');
  const idInput = form.querySelector('[data-variant-id]');
  const qtyInput = form.querySelector('[data-qty]');
  const atc = form.querySelector('[data-atc]');
  const atcLabel = form.querySelector('[data-atc-label]');
  const errorEl = form.querySelector('[data-error]');
  const mainImg = section.querySelector('.js-gallery-main');
  const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];

  // Gallery
  let mediaIndex = Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-current') === 'true'));
  const showMedia = i => {
    if (!data.media.length || !mainImg) return;
    mediaIndex = (i + data.media.length) % data.media.length;
    const m = data.media[mediaIndex];
    mainImg.style.opacity = '0.2';
    const img = new Image();
    img.onload = () => { mainImg.removeAttribute('srcset'); mainImg.src = m.src; mainImg.style.opacity = '1'; };
    img.src = m.src;
    thumbs.forEach((t, k) => t.setAttribute('aria-current', k === mediaIndex ? 'true' : 'false'));
  };
  thumbs.forEach((t, k) => t.addEventListener('click', () => showMedia(k)));
  section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showMedia(mediaIndex - 1));
  section.querySelector('[data-gallery-next]')?.addEventListener('click', () => showMedia(mediaIndex + 1));
  let touchX = null;
  mainImg?.parentElement.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
  mainImg?.parentElement.addEventListener('touchend', e => {
    if (touchX === null) return;
    const dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 40) showMedia(mediaIndex + (dx < 0 ? 1 : -1));
    touchX = null;
  });

  // Variants
  const selected = () => data.options.map((_, i) => form.querySelector(`input[name="option${i}"]:checked`)?.value);
  const findVariant = opts => data.variants.find(v => v.options.every((o, i) => o === opts[i]));
  const bundleInputs = [...section.querySelectorAll('[data-bundle]')];

  const render = (variant, fromUser) => {
    if (!variant) {
      atc.disabled = true; atcLabel.textContent = 'Unavailable'; return;
    }
    idInput.value = variant.id;
    const lowEl = section.querySelector('[data-low-stock]');
    const qty = data.stock ? data.stock[variant.id] : null;
    if (lowEl) {
      const show = qty !== null && qty !== undefined && qty > 0 && qty <= data.lowStockAt;
      lowEl.hidden = !show;
      if (show) lowEl.textContent = `Only ${qty} left in this size`;
    }
    atc.disabled = !variant.available;
    atcLabel.textContent = variant.available ? data.atcLabel : 'Sold out';

    section.querySelector('[data-price]').textContent = money(variant.price, data.moneyFormat);
    section.querySelector('[data-sticky-price]').textContent = money(variant.price, data.moneyFormat);
    const cmp = section.querySelector('[data-compare]');
    const save = section.querySelector('[data-save]');
    if (variant.compare_at_price > variant.price) {
      cmp.hidden = false; cmp.textContent = money(variant.compare_at_price, data.moneyFormat);
      save.hidden = false; save.textContent = `Save ${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%`;
    } else { cmp.hidden = true; save.hidden = true; }

    bundleInputs.forEach(input => {
      const q = +input.dataset.qty, pct = +input.dataset.pct;
      const rate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
      const fixed = Math.round((+input.dataset.fixed || 0) * rate);
      const label = input.closest('.bundle');
      const eur = +input.dataset.eur || 0;
      const isEur = window.Shopify && Shopify.currency && Shopify.currency.active === 'EUR';
      const total = isEur && eur ? eur : Math.round(variant.price * q * (100 - pct) / 100) - fixed;
      label.querySelector('[data-bundle-price]').textContent = money(total, data.moneyFormat);
      label.querySelector('[data-bundle-compare]').textContent = money((variant.compare_at_price || variant.price) * q, data.moneyFormat);
    });

    selected().forEach((v, i) => {
      const lbl = section.querySelector(`[data-option-label="${i}"]`);
      if (lbl) lbl.textContent = v;
    });

    // Disable sizes that are sold out for the chosen colour
    data.options.forEach((_, i) => {
      form.querySelectorAll(`input[name="option${i}"]`).forEach(input => {
        const opts = selected(); opts[i] = input.value;
        const v = findVariant(opts);
        const colorish = /colou?r/i.test(data.options[i]);
        if (!colorish) input.disabled = !v || !v.available;
      });
    });

    if (fromUser && variant.featured_media) {
      const idx = data.media.findIndex(m => m.id === variant.featured_media.id);
      if (idx > -1) showMedia(idx);
    }
    if (fromUser) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  };

  // Bundles: one colour/size picker per coat
  const picksEl = section.querySelector('[data-bundle-picks]');
  const optionSets = [...form.querySelectorAll('[data-variant-options]')];
  const optionValues = data.options.map((_, j) => [...new Set(data.variants.map(v => v.options[j]))]);
  const escapeHtml = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const pickRows = () => picksEl ? [...picksEl.querySelectorAll('[data-pick-row]')] : [];
  const rowOptions = row => [...row.querySelectorAll('select')].map(s => s.value);
  const checkRows = () => pickRows().forEach(row => {
    const v = findVariant(rowOptions(row));
    row.classList.toggle('is-unavailable', !v || !v.available);
  });
  const buildPicks = q => {
    if (!picksEl) return;
    if (q <= 1) {
      picksEl.hidden = true;
      picksEl.innerHTML = '';
      optionSets.forEach(f => { f.hidden = false; });
      return;
    }
    const previous = pickRows().map(rowOptions);
    const base = selected();
    picksEl.innerHTML = '<div class="opt__label"><span>Choose colour &amp; size for each coat</span></div>' +
      Array.from({ length: q }, (_, i) => {
        const chosen = previous[i] || base;
        return `<div class="pick-row" data-pick-row><span class="pick-row__n">Coat ${i + 1}</span>` +
          data.options.map((name, j) => `<select aria-label="${escapeHtml(name)} for coat ${i + 1}">` +
            optionValues[j].map(val => `<option value="${escapeHtml(val)}"${val === chosen[j] ? ' selected' : ''}>${escapeHtml(val)}</option>`).join('') +
          '</select>').join('') + '<span class="pick-row__na">Sold out</span></div>';
      }).join('');
    picksEl.hidden = false;
    optionSets.forEach(f => { f.hidden = true; });
    checkRows();
  };
  picksEl?.addEventListener('change', checkRows);

  form.addEventListener('change', e => {
    if (e.target.matches('[data-option-index]')) render(findVariant(selected()), true);
    if (e.target.matches('[data-bundle]')) {
      qtyInput.value = e.target.dataset.qty;
      buildPicks(+e.target.dataset.qty);
    }
  });
  const checkedBundle = bundleInputs.find(i => i.checked);
  if (checkedBundle) { qtyInput.value = checkedBundle.dataset.qty; buildPicks(+checkedBundle.dataset.qty); }
  render(findVariant(selected()), false);

  const coatItems = () => {
    const rows = pickRows();
    if (!rows.length) return [{ id: +idInput.value, quantity: +qtyInput.value || 1 }];
    const counts = new Map();
    for (const row of rows) {
      const v = findVariant(rowOptions(row));
      if (!v || !v.available) throw new Error(`${row.querySelector('.pick-row__n').textContent}: this colour/size is sold out.`);
      counts.set(v.id, (counts.get(v.id) || 0) + 1);
    }
    return [...counts].map(([id, quantity]) => ({ id, quantity }));
  };

  form.addEventListener('submit', async e => {
    e.preventDefault();
    errorEl.textContent = '';
    if (window.Shopify && Shopify.designMode) {
      errorEl.textContent = 'Checkout is disabled inside the Shopify theme editor. Open the preview (eye icon at the top) to test buying.';
      return;
    }
    atc.disabled = true;
    const prev = atcLabel.textContent;
    atcLabel.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: coatItems().concat(
          [...section.querySelectorAll('[data-upsell]:checked')].map(cb => {
            const sel = cb.closest('.upsell').querySelector('[data-upsell-variant]');
            return { id: +(sel ? sel.value : cb.value), quantity: 1 };
          })
        ) })
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
      if (section.dataset.goCheckout === 'true') { location.href = '/checkout'; return; }
      location.href = '/cart';
    } catch (err) {
      errorEl.textContent = err.message;
      atc.disabled = false;
      atcLabel.textContent = prev;
    }
  });

  // Size guide link opens accordion
  section.querySelector('[data-open-size]')?.addEventListener('click', () => {
    const d = section.querySelector('[data-size-guide]');
    if (d) d.open = true;
  });

  // Sticky bar
  const sticky = section.querySelector('[data-sticky-atc]');
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(atc);
  }

  updateCartCount();
})();

// Cart page quantity controls
document.querySelectorAll('[data-cart-qty]').forEach(wrap => {
  const key = wrap.dataset.key;
  const input = wrap.querySelector('input');
  const change = q => fetch('/cart/change.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Math.max(0, q) })
  }).then(() => location.reload());
  wrap.querySelector('[data-minus]').addEventListener('click', () => change(+input.value - 1));
  wrap.querySelector('[data-plus]').addEventListener('click', () => change(+input.value + 1));
});
